import { msg } from '@lingui/core/macro';

import { defineFilters } from '@/shared/filters/define-filters';
import { decimalToCents, parseMoneyInput } from '@/shared/format/money';

// Filtros da lista declarados uma vez (P01): o `FilterProvider` de ChatbotListContainer.tsx:86-98 e o "Filtrar
// por" de components/DataTableFilters/ChatbotFilters/ChatbotFilters.tsx:30-45, na ordem de lá. Arquivo leve:
// entra no `validateSearch` da rota.

/** "Valor" é `CurrencyFormField`: vai em centavos (CurrencyFormField.tsx:97-108). */
export function invoiceValueParam(value: string): number | undefined {
  const decimal = parseMoneyInput(value);
  return decimal === null ? undefined : decimalToCents(decimal);
}

/** A máscara `phoneNumberMask` do legado, `(00) 00000-0000` (utils/constants/masks/phoneNumberMask.ts). */
export function legacyPhoneMask(digits: string): string {
  if (digits === '') return '';
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7, 11)}`;
}

/** "Número de telefone" é campo com máscara: o legado filtra pelo texto mascarado (ChatbotFilters.tsx:57-68, filterContext.tsx:142-149). */
export function botPhoneParam(value: string): string | undefined {
  const digits = value.replace(/\D/g, '');
  return digits === '' ? undefined : legacyPhoneMask(digits);
}

export const chatbotFilters = defineFilters([
  { key: 'invoiceValue', type: 'text', label: msg`Valor`, placeholder: msg`Em reais, como 1.000,00`, max: 20, toParam: invoiceValueParam },
  { key: 'botPhone', type: 'text', label: msg`Número de telefone`, placeholder: msg`(00) 00000-0000`, max: 20, toParam: botPhoneParam },
  { key: 'productName', type: 'text', label: msg`Nome do produto`, pinned: true },
  {
    key: 'productCategoryName',
    type: 'select',
    label: msg`Categoria do produto`,
    options: [
      { value: 'FGTS', label: msg`FGTS` },
      { value: 'CDC', label: msg`CDC` },
    ],
  },
  { key: 'personName', type: 'text', label: msg`Nome da tomador` },
  { key: 'baneficiaryName', type: 'text', label: msg`Nome do beneficiário` },
  { key: 'serviceQueueName', type: 'text', label: msg`Nome da fila` },
  { key: 'identificationCode', type: 'text', label: msg`Código de identificação` },
]);
